<!-- app-home.component.html -->

<div class="app-container">
  <!-- TOP APP HEADER -->
  <app-header [isAdmin]="false" (logoutEvent)="onLogout()" (settingsEvent)="onSettingsClick()">
  </app-header>
  <!-- OCR Test Loader -->
  <div style="display:flex; align-items:center; gap:8px; padding:4px 16px; background:#f5f5f5; border-bottom:1px solid #ddd;">
    <button style="cursor:pointer; padding:4px 12px; border:1px solid #1976d2; border-radius:4px; background:#fff; color:#1976d2; font-size:13px;" (click)="loadOcrTestQuestions()">
      Load OCR Questions
    </button>
    <span *ngIf="loadedQuestions.length > 0" style="font-size:12px; color:#555;">
      {{ loadedQuestions.length }} OCR questions loaded
    </span>
  </div>

  <!-- MAIN CONTENT: 4 Panes -->
  <div class="app-content" [class.navigation-collapsed]="isNavigationCollapsed" [class.single-tree-mode]="showSingleTree"
       [class.mobile-nav-visible]="showMobileNav" [class.mobile-details-visible]="showMobileDetails">

    <!-- Overlay for mobile view to capture clicks on the 20% visible area -->
    <div *ngIf="showMobileNav && isMobileView" class="mobile-nav-overlay" (click)="toggleMobileNav()"></div>

    <!-- Navigation App Component (Pane 1 & 2) -->
    <app-navigation-app *ngIf="!showSingleTree"
                        [p1Mode]="p1Mode"
                        [p1Subjects]="p1Subjects"
                        [p1SubMap]="p1SubMap"
                        [p2TopicsMap]="p2TopicsMap"
                        [p2SubTopicsMap]="p2SubTopicsMap"
                        [p1YearwiseExams]="p1YearwiseExams"
                        [p1YearwiseLower]="p1YearwiseLower"
                        [p2Years]="p2Years"
                        [selectedSubject]="selectedSubject"
                        [selectedSubItem]="selectedSubItem"
                        [selectedTopic]="selectedTopic"
                        [selectedSubTopic]="selectedSubTopic"
                        [selectedYearwiseExam]="selectedYearwiseExam"
                        [selectedYearwiseLower]="selectedYearwiseLower"
                        [selectedYear]="selectedYear"
                        [isLoadingSubjects]="isLoadingSubjects"
                        [isLoadingSections]="isLoadingSections"
                        [isLoadingTopics]="isLoadingTopics"
                        [isLoadingSubtopics]="isLoadingSubtopics"
                        [topicIdMap]="topicIdMap"
                        (yearsListGenerated)="onYearsListGenerated($event)"
                        (subjectsLoaded)="onSubjectsLoaded($event)"
                        (sectionsLoaded)="onSectionsLoaded($event)"
                        (topicsLoaded)="onTopicsLoaded($event)"
                        (subtopicsLoaded)="onSubtopicsLoaded($event)"
                        (modeChange)="onModeChange($event)"
                        (subjectClick)="onSubjectClick($event)"
                        (subItemClick)="onSubItemClick($event)"
                        (topicClick)="onTopicClick($event)"
                        (subTopicClick)="onSubTopicClick($event)"
                        (yearwiseExamClick)="onYearwiseExamClick($event)"
                        (yearwiseLowerClick)="onYearwiseLowerClick($event)"
                        (yearClick)="onYearClick($event)"
                        (collapseStateChange)="onNavigationCollapseChange($event)"
                        (viewButtonClick)="onViewButtonClick()"
                        (settingsButtonClick)="onSettingsButtonClick()"
                        (languageChange)="onLanguageChange($event)"
                        (fontSizeChange)="onFontSizeChange($event)"
                        (refreshTreeRequested)="onRefreshTreeRequested()"
                        (editModeChange)="onEditModeChange($event)"
                        #navigationApp
                        [style.flex]="navigationAreaFlex">
      <app-layout-switcher
        [isCollapsed]="isNavigationCollapsed"
        [isPaneOne_Collapsed]="isPaneOne_Collapsed"
        [isPaneTwo_Collapsed]="isPaneTwo_Collapsed"
        [showSingleTree]="showSingleTree"
        [isMobileView]="isMobileView"
        (layoutChange)="onLayoutChange($event)"
        (searchTermChange)="onSearchTermChange($event)">
      </app-layout-switcher>
    </app-navigation-app>

    <!-- Navigation Vertical Resizable Divider - Only show when not in single-tree mode and not collapsed -->
    <div *ngIf="!showSingleTree && !isNavigationCollapsed" class="vertical-divider nav-divider"
         (mousedown)="onNavMouseDown($event)"
         (dblclick)="resetNavPanelSize()"
         [class.dragging]="isNavDragging"
         [class.active]="isNavDragging"
         [class.user-select-none]="isNavDragging"
         title="Drag to resize or double-click to reset">
    </div>

    <!-- Single Tree Component -->
    <app-single-tree *ngIf="showSingleTree"
                     [p1Mode]="p1Mode"
                     [p1Subjects]="p1Subjects"
                     [p1SubMap]="p1SubMap"
                     [p1YearwiseExams]="p1YearwiseExams"
                     [p1YearwiseLower]="p1YearwiseLower"
                     [hindiNameMap]="hindiNameMap"
                     [isLoadingSubjects]="isLoadingSubjects"
                     [isLoadingSections]="isLoadingSections"
                     [p2TopicsMap]="p2TopicsMap"
                     [p2SubTopicsMap]="p2SubTopicsMap"
                     [isLoadingTopics]="isLoadingTopics"
                     [isLoadingSubtopics]="isLoadingSubtopics"
                     [topicIdMap]="topicIdMap"
                     [p2Years]="p2Years"
                     [currentLayoutView]="currentLayout"
                     (modeChange)="onP1ModeChange($event)"
                     (subjectClick)="onSubjectSelect($event)"
                     (subItemClick)="onSubItemSelect($event)"
                     (topicClick)="onTopicSelect($event)"
                     (subTopicClick)="onSubTopicSelect($event)"
                     (yearwiseExamClick)="onYearwiseExamSelect($event)"
                     (yearwiseLowerClick)="onYearwiseLowerSelect($event)"
                     (yearClick)="onYearSelect($event)"
                     (hierarchyPathChange)="onHierarchyPathChange($event)"
                     (topicsLoaded)="onTopicsLoaded($event)"
                     (subtopicsLoaded)="onSubtopicsLoaded($event)"
                     (languageChange)="onLanguageChange($event)"
                     (searchChange)="onSearchTermChange($event)"
                     (refreshTreeRequested)="onRefreshTreeRequested()"
                     (editModeChange)="onEditModeChange($event)"
                     #singleTreeComponent>
      <app-layout-switcher
        [hideSearch]="true"
        [isMobileView]="isMobileView"
        (layoutChange)="onLayoutChange($event)">
      </app-layout-switcher>
    </app-single-tree>

    <!-- Main content wrapper - Only visible in single-tree mode -->
    <div *ngIf="showSingleTree" class="single-tree-content">
      <!-- Main Area Component (Pane 3) -->
      <app-main-area
        *ngIf="(showMains || mainAreaFlex !== '0 0 0%') && initializeMainArea"
        [style.flex]="mainAreaFlex"
        [p1Mode]="p1Mode"
        [selectedSubject]="selectedSubject"
        [selectedSubItem]="selectedSubItem"
        [selectedTopic]="selectedTopic"
        [selectedSubTopic]="selectedSubTopic"
        [selectedYearwiseExam]="selectedYearwiseExam"
        [selectedYearwiseLower]="selectedYearwiseLower"
        [selectedYear]="selectedYear"
        [loadedQuestions]="loadedQuestions"
        [isLoadingQuestions]="isLoadingTopicQuestions"
        [isMobileView]="isMobileView"
        [showDetails]="showDetails"
        (toggleMobileNav)="toggleMobileNav()"
        (selectedCardChange)="onSelectedCardChange($event)"
        (showDetailsChange)="onShowDetailsChange($event)"
        (viewModeChange)="onViewModeChange($event)"
        (languageChange)="onLanguageChange($event)">
      </app-main-area>

      <!-- Vertical Resizable Divider - Only show if details are visible -->
      <div *ngIf="showDetails && (showMains || mainAreaFlex !== '0 0 0%') && initializeMainArea" class="vertical-divider"
           (mousedown)="onMouseDown($event)"
           (dblclick)="resetPanelSizes()"
           [class.dragging]="isDragging"
           [class.active]="isDragging"
           [class.user-select-none]="isDragging"
           title="Drag to resize or double-click to reset">
      </div>

      <!-- Details Area Component (Pane 4) - Only show if showDetails is true -->
      <app-details-area
        *ngIf="showDetails && initializeDetailsArea"
        [style.flex]="detailsAreaFlex"
        [selectedCard]="selectedCard"
        [isFullscreenMode]="mainAreaFlex === '0 0 0%'"
        [showMains]="showMains"
        [isMobileView]="isMobileView"
        [viewMode]="viewMode"
        (backToMain)="backToMainFromDetails()"
        (showMainsChange)="onShowMainsChange($event)"
        (closeDetails)="onCloseDetails()"
        (viewModeChange)="onViewModeChange($event)">
      </app-details-area>
    </div>

    <!-- Main Area Component (Pane 3) - Only shown when NOT in single-tree mode -->
    <app-main-area *ngIf="!showSingleTree && (showMains || mainAreaFlex !== '0 0 0%') && initializeMainArea"
                   [style.flex]="mainAreaFlex"
                   [p1Mode]="p1Mode"
                   [selectedSubject]="selectedSubject"
                   [selectedSubItem]="selectedSubItem"
                   [selectedTopic]="selectedTopic"
                   [selectedSubTopic]="selectedSubTopic"
                   [selectedYearwiseExam]="selectedYearwiseExam"
                   [selectedYearwiseLower]="selectedYearwiseLower"
                   [selectedYear]="selectedYear"
                   [loadedQuestions]="loadedQuestions"
                   [isLoadingQuestions]="isLoadingTopicQuestions"
                   [isMobileView]="isMobileView"
                   [showDetails]="showDetails"
                   (toggleMobileNav)="toggleMobileNav()"
                   (selectedCardChange)="onSelectedCardChange($event)"
                   (showDetailsChange)="onShowDetailsChange($event)"
                   (viewModeChange)="onViewModeChange($event)"
                   (languageChange)="onLanguageChange($event)">
    </app-main-area>

    <!-- Vertical Resizable Divider - Only show if details are visible and NOT in single-tree mode -->
    <div *ngIf="showDetails && !showSingleTree && (showMains || mainAreaFlex !== '0 0 0%') && initializeMainArea" class="vertical-divider"
         (mousedown)="onMouseDown($event)"
         (dblclick)="resetPanelSizes()"
         [class.dragging]="isDragging"
         [class.active]="isDragging"
         [class.user-select-none]="isDragging"
         title="Drag to resize or double-click to reset">
    </div>

    <!-- Reset notification (visible only briefly when panels are reset) -->
    <div class="reset-notification" *ngIf="showResetNotification">
      Panel sizes reset to default
    </div>

    <!-- Details Area Component (Pane 4) - Only show if showDetails is true and NOT in single-tree mode -->
    <app-details-area
      *ngIf="showDetails && !showSingleTree && initializeDetailsArea"
      [style.flex]="detailsAreaFlex"
      [selectedCard]="selectedCard"
      [isFullscreenMode]="mainAreaFlex === '0 0 0%'"
      [showMains]="showMains"
      [isMobileView]="isMobileView"
      [viewMode]="viewMode"
      (backToMain)="backToMainFromDetails()"
      (showMainsChange)="onShowMainsChange($event)"
      (closeDetails)="onCloseDetails()"
      (viewModeChange)="onViewModeChange($event)">
    </app-details-area>
  </div>
</div>
